var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { display: "inline-block" },
      attrs: {
        fill: "none",
        stroke: "green",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2.5",
        viewBox: "0 0 24 24",
      },
    },
    [_c("path", { attrs: { d: "M20 6L9 17l-5-5" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }